import "~/misc/common";
import { p, getUrlParameter, selectObjects, hasMouse } from "~/misc/common";
import L from "~/misc/2d/leaflet";
import { Icon as ExtraIcon, PinSquarePanel } from "leaflet-extra-markers";
import autosize from 'autosize';

import { Controller } from "@hotwired/stimulus";
import { initMapLayered } from "./map_layered";
import { initLaunchPlaces } from "./launch_places";
import { Context2d, InfoObject, InfoObjectType } from "~/types/map";
import { eovTOwgs84 } from "~/misc/coord";
import { buildBiIcon, buildPopup } from "~/misc/2d/builders";

export default class extends Controller {
  connect() {
    console.log('initInfoObjectForm');

    const map = initMapLayered();

    initInfoObjects(map);
    initLaunchPlaces(map);

    const infoObject = map.data.infoObjects[0];
    let points = getPath($('#info_object_definition').val() as string);

    $('#info_object_definition').on('change', refresh);
    $('#info_object_info_object_type_id').on('change', refresh);
    refresh();
    if (points.length > 2) {
      map.flyToBounds(infoObject.marker.getBounds(), {
        duration: 0.5
      });
    } else if (points.length == 1) {
      map.flyTo(points[0], map.getZoom(), {
        duration: 0.5
      });
    }

    function refresh() {
      infoObject.marker.remove();
      infoObject.info_object_type_id = $('#info_object_info_object_type_id').myGetNumValue() || 1;
      const type = selectObjects(map.data.infoObjectTypes, 'id', infoObject.info_object_type_id)[0];
      points = getPath($('#info_object_definition').val() as string);
      switch (type.shape_id) {
        case 0:
          if (points.length == 0) points.push(map.getCenter());
          points.splice(0, points.length - 1);
          break;
        case 3:
          points.splice(2);
          break;
      }

      infoObject.definition = pathToText(points);
      $('#info_object_definition').val(infoObject.definition);
      //if (!infoObject.info_object_type_id) return;
      infoObject.marker = createShape(map, infoObject)[0].addTo(map);
      infoObject.marker.on('editable:vertex:drag editable:vertex:deleted', function (e) {
        points = [];
        for (const latlng of e.vertex.latlngs) {
          points.push(latlng);
        };
        $('#info_object_definition').val(pathToText(points));
        autosize.update($('#info_object_definition'));
      });
      infoObject.marker.on('dragend', function (e) {
        points = [e.target.getLatLng()];
        $('#info_object_definition').val(pathToText(points));
        autosize.update($('#info_object_definition'));
      });
      infoObject.marker.enableEdit();
      autosize.update($('#info_object_definition'));
    }

    map.on('click', function (e) {
      points.push(e.latlng);
      $('#info_object_definition').val(pathToText(points));
      refresh();
    });

    map.on('contextmenu', function (e) {
      points.pop();
      $('#info_object_definition').val(pathToText(points));
      refresh();
    });

  }
}

export function initInfoObjects(map: Context2d) {
  p('initInfoObjects');

  //map.createPane('infoObjectsShapes');
  //map.getPane('infoObjectsShapes')!.style.zIndex = '300';
  map.createPane('infoObjectsPois');
  map.getPane('infoObjectsPois')!.style.zIndex = '500';

  const featureGroupShapes = L.featureGroup().addTo(map);
  const featureGroupPois = L.featureGroup().addTo(map);

  map.tree.create_node('#', {
    id: 'launch_areas',
    icon: 'fa fa-map-marker',
    text: "Starthelyek",
    state: {
      checked: true
    }
  });

  map.tree.create_node('launch_areas', {
    id: 'info_objects',
    icon: 'bi-layout-wtf',
    text: "Alakzatok"
  });
  map.tree.create_node('launch_areas', {
    id: 'info_objects_pois',
    icon: 'bi-geo',
    text: "Tárgyak"
  });

  if (map.noState) {
    map.tree.open_node('launch_areas');
  }

  map.tree.element.on("check_node.jstree uncheck_node.jstree state_ready.jstree", refreshLayers);
  function refreshLayers() {
    featureGroupShapes.remove();
    featureGroupPois.remove();
    map.tree.is_checked('info_objects') ? featureGroupShapes.addTo(map) : null;
    map.tree.is_checked('info_objects_pois') ? featureGroupPois.addTo(map) : null;
  }

  for (const infoObject of map.data.infoObjects) {

    //if (infoObject.launch_area_id != 36) {
    //	return;
    //}

    // POPUP
    infoObject.openPopup = function (e: any) {
      openPopupInner(infoObject, e);
    };

    const type = selectObjects(map.data.infoObjectTypes, 'id', infoObject.info_object_type_id)[0];

    var shapes = createShape(map, infoObject);
    var shape = shapes[0];
    var touch = shapes[1];
    shape.addTo(type.shape_id > 0 ? featureGroupShapes : featureGroupPois);
    infoObject.marker = shape;
    if (touch) {
      touch.addTo(type.shape_id > 0 ? featureGroupShapes : featureGroupPois);
    }
    (touch || shape).on('click', function (e: any) {
      infoObject.openPopup(e);
    });

    map.launchAreas[infoObject.launch_area_id] ||= L.featureGroup();
    shape.addTo(map.launchAreas[infoObject.launch_area_id]);

  };

  const url_id = getUrlParameter('info_object_id');
  if (url_id && typeof url_id === 'string') {
    const infoObject = selectObjects(map.data.infoObjects, 'id', parseInt(url_id))[0];
    const type = selectObjects(map.data.infoObjectTypes, 'id', infoObject.info_object_type_id)[0];
    console.log(infoObject.marker);
    if (type.shape_id == 0) {
      map.flyTo(getPosition(map, infoObject), map.getZoom(), {
        duration: 0.5
      });
    }
    else {
      map.flyToBounds(infoObject.marker.getBounds(), {
        duration: 0.5
      });
    }
    setTimeout(function () {
      infoObject.openPopup();
    }, 505);
  }

  function openPopupInner(infoObject: InfoObject, e: any) {
    if (infoObject.id) {
      const locale = $('meta[name="locale"]').attr('content') || 'hu';
      $.get(`/${locale}/info_objects/${infoObject.id}/details`, function (html) {
        const latLng = e ? e.latlng : getPosition(map, infoObject);
        L.popup().setLatLng(latLng)
          .setContent(createPopup(infoObject, html)).openOn(map);
      });
    }
    //if (!infoObject.marker.getPopup()) {
    //	infoObject.marker.bindPopup(buildPopup(infoObject), { sticky: true })
    //}
    //if (e) {
    //	infoObject.marker.openPopup(e.latlng);
    //} else {
    //	infoObject.marker.openPopup();
    //}
  }

  function createPopup(infoObject: InfoObject, content: string) {
    const type = selectObjects(map.data.infoObjectTypes, 'id', infoObject.info_object_type_id)[0];
    const title = buildBiIcon('layout-wtf') + ' ' + type.name;
    //var content = '';
    //if (infoObject.description) {
    //	content += `<p>${infoObject.description.replace(/\n/g, "<br>")}</p>`;
    //}
    //content += `<p><b>EOV koordináták:</b></p>`;
    //var eovText = pathToEovText(getPath(infoObject.definition));
    //p(eovText);
    //content += `<p>${eovText.replace(/\n/g, "<br>")}</p>`;
    return buildPopup(title, content);
  }
}

export function createShape(map: Context2d, data: InfoObject) {
  //p(data);
  const type = selectObjects(map.data.infoObjectTypes, 'id', data.info_object_type_id)[0];
  //type ||= { shape_id: 1, color: 'gray' };
  //p(objecttype);
  const path = getPath(data.definition);
  let shape: any = null;
  let touch = null;
  switch (type.shape_id) {
    case 0:
      const match = type.color.match(/^=\s*(\w+)_icon\s+'([^']+)'\|(\w+)/) ?? [];
      const [_, prefix, iconName, color] = match;
      var icon = new ExtraIcon({
        contentHtml: `<i class="${prefix} ${prefix}-${iconName}"></i>`,
        color: color,
        svg: PinSquarePanel,
        //scale: 0.8
      });
      shape = L.marker(path[0], { icon: icon, pane: 'infoObjectsPois' });
      break;
    case 1:
      shape = L.polyline(path, {
        color: type.color,
        opacity: 1,
        weight: 3
      });
      break;
    case 2:
      shape = L.polygon(path, {
        color: 'white',
        weight: 1,
        fillColor: type.color,
        fillOpacity: 0.35,
      });
      break;
    case 3:
      if (path[0]) {
        let radius = 50;
        if (path[1]) {
          radius = L.latLng(path[0]).distanceTo(L.latLng(path[1]));
        }
        shape = L.circle(path[0], {
          radius: radius,
          color: 'white',
          weight: 1,
          fillColor: type.color,
          fillOpacity: 0.35
        });
      }
      break;
  }
  shape.data = data;
  if (hasMouse()) {
    shape.bindTooltip(type.name, { sticky: true });
  } else {
    if (type.shape_id == 1) {
      touch = L.polyline(path, {
        color: 'transparent',
        opacity: 0,
        weight: 20
      });
    }
  }
  return [shape, touch];
}

function getPath(definition: string) {
  const strings = (definition || '').split(/\s+/);
  const path = [];
  for (const str of strings) {
    const coords = str.split(',');
    if (coords.length >= 2) {
      const latlng = {
        lat: parseFloat(coords[1]),
        lng: parseFloat(coords[0])
      };
      if (latlng.lat > 100.0) {
        const conv = eovTOwgs84(latlng.lng, latlng.lat);
        latlng.lat = conv[0];
        latlng.lng = conv[1];
      }
      path.push(latlng);
    }
  }
  return path;
}

function pathToText(aPath: { lat: number; lng: number; }[]) {
  let text = "";
  for (const point of aPath) {
    text += point.lng.toFixed(7) + ',' + point.lat.toFixed(7) + '\n';
  }
  return text;
}

function getPosition(map: Context2d, data: InfoObject) {
  const type = selectObjects(map.data.infoObjectTypes, 'id', data.info_object_type_id)[0];
  if (type.shape_id == 0) {
    return (data.marker as unknown as L.Marker).getLatLng();
  } else {
    return data.marker.getCenter();
  }
}

//function pathToEovText(aPath) {
//	var text = "";
//	for (var i = 0; i < aPath.length; i++) {
//		var conv = wgs84TOeov(aPath[i].lat, aPath[i].lng, 0);
//		text += conv[1].toFixed(3) + ', ' + conv[0].toFixed(3) + '\n';
//	}
//	return text;
//}
